import { Pipe, PipeTransform } from '@angular/core';
import { Posizione } from '../models/posizione.model';

@Pipe({
  name: 'fascicoloLabel'
})

export class FascicoloLabelPipe implements PipeTransform {
  transform(posizione: Posizione | undefined): string {
    if (!posizione) { return '-'; }

    if (posizione.sigla && posizione.descrizione) {
      return `${posizione.sigla} - ${posizione.descrizione}`;
    }

    return posizione.sigla || posizione.descrizione || '-';
  }
}
